import { Config } from '@niknevis/vue-modules'
import { ZoneModel } from '@/modules/common/zone/models/zone.model'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'

export function getPersonFromZone() {
  let userType = Config.get('userType')

  switch (userType) {
    case (ZoneModel.ADMIN):
      return PersonTitle.ADMIN
    case (ZoneModel.PANEL):
      return PersonTitle.USER
    case (ZoneModel.WRITER):
      return PersonTitle.WRITER
    default:
      return PersonTitle.USER
  }
}